import React, { useEffect } from "react";
import UploadedDocsComponent from "../../../components/cases/uploadedDocuments/UploadedDocs";
import {
  getAutditTrail,
  getStatusQuoAutditTrail,
} from "../../../services/auditTrails";
import { getUpdatedData } from "../../../redux/slices/AuditTrailSlice";
import { getUpdatedData as getDocumentsUpdatedData } from "../../../redux/slices/DocumentsSlice";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

const AdvisorUploadedDocs = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const fetchAuditTrail = async () => {
    const result = await getAutditTrail(id);
    if (result?.success) {
      dispatch(getUpdatedData(result?.payLoad));
    } else {
      dispatch(getUpdatedData([]));
    }
  };
  const fetchDocumentsAuditTrail = async () => {
    const result = await getStatusQuoAutditTrail(id);
    if (result?.success) {
      dispatch(getDocumentsUpdatedData(result?.payLoad));
    } else {
      dispatch(getDocumentsUpdatedData([]));
    }
  };

  useEffect(() => {
    fetchAuditTrail();
    fetchDocumentsAuditTrail();
  }, []);
  return (
    <div>
      <UploadedDocsComponent />
    </div>
  );
};

export default AdvisorUploadedDocs;
